module.exports = __webpack_public_path__ + "static/media/Elizabeth Blosser Headshot.8ec0616c.jpeg";